import {handleError} from '../../common/utils/errorHandling';
import httpClient from '../../common/services/httpClient';

interface WorkshopListingDto {
  readonly id: string;
  readonly name: string;
  readonly location?: string;
}

class WorkshopsService {
  public async getAllWorkshops(): Promise<WorkshopListingDto[]> {
    return handleError(
      () => httpClient.get<WorkshopListingDto[]>('/workshops'),
      'Error fetching workshops:',
      () => []
    );
  }
}

const workshopsService = new WorkshopsService();
export default workshopsService;
